import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { memo, useMemo } from 'react';

import { ResourcesPageFormValues } from '../../../../../../pages/ResourcesPage';
import { StyledMuiTextField } from '../ResourceFieldsLineProperties.style';
import { isTerminalProperties } from './ResourceFieldsLine.utils';
import { useReplaceNumberAt } from './useReplaceValueAt';

export const ResourceFieldsLineTerminalProperties = memo(function ResourceFieldsLineTerminalProperties({
    index,
    arrayReplace,
}: {
    index: number;
    arrayReplace: (index: number, value: any) => void;
}) {
    const { values, initialValues, errors } = useFormikContext<ResourcesPageFormValues>();

    const handleNumberChange = useReplaceNumberAt(index, arrayReplace);

    const content = useMemo(() => values.resources[index].content, [index, values.resources]);
    const initialContent = useMemo(
        () => (values.resources[index].id ? initialValues.resources[index].content : null),
        [index, initialValues.resources, values.resources],
    );

    return isTerminalProperties(content) ? (
        <>
            <Grid item xs display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledMuiTextField
                    variant="filled"
                    type={'number'}
                    value={content.occupationOffset}
                    onChange={e => handleNumberChange('occupationOffset', e)}
                    modified={
                        values.resources[index].id && isTerminalProperties(initialContent)
                            ? content.occupationOffset !== initialContent.occupationOffset
                            : undefined
                    }
                    InputProps={{
                        inputProps: { min: 0 },
                    }}
                    error={!!errors[`resources[${index}]['occupationOffset']`]}
                    helperText={errors[`resources[${index}]['occupationOffset']`]}
                />
            </Grid>
            <Grid item xs display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledMuiTextField
                    variant="filled"
                    type={'number'}
                    value={content.surface}
                    onChange={e => handleNumberChange('surface', e)}
                    InputProps={{
                        inputProps: { min: 0, step: 0.1 },
                    }}
                    modified={
                        values.resources[index].id && isTerminalProperties(initialContent)
                            ? content.surface !== initialContent.surface
                            : undefined
                    }
                    error={!!errors[`resources[${index}]['surface']`]}
                    helperText={errors[`resources[${index}]['surface']`]}
                />
            </Grid>
            <Grid item xs display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledMuiTextField
                    variant="filled"
                    type={'number'}
                    value={content.passengersBySquareMeter}
                    onChange={e => handleNumberChange('passengersBySquareMeter', e)}
                    InputProps={{
                        inputProps: { min: 0, step: 0.1 },
                    }}
                    modified={
                        values.resources[index].id && isTerminalProperties(initialContent)
                            ? content.passengersBySquareMeter !== initialContent.passengersBySquareMeter
                            : undefined
                    }
                    error={!!errors[`resources[${index}]['passengersBySquareMeter']`]}
                    helperText={errors[`resources[${index}]['passengersBySquareMeter']`]}
                />
            </Grid>
        </>
    ) : null;
});
